module.exports = __webpack_public_path__ + "img/offline.7be7faaa.png";